import React from "react";
import Nav from './components/Nav';
import Header from './components/Header';
import About from "./components/About";
import Services from "./components/Services";
import Project from "./components/Project";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div>
      <Nav />
      <Header />
      <main>
        <About />
        <Services />
        <Project />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
